import React, { Dispatch, useEffect } from "react";
import { Typography, Grid, Tooltip } from "@mui/material";

import { StyledContainer } from "../StyledComponents";
// import AppBar from "../components/AppBar";
import logo from "../image/logo_PNG.png";
import { useTranslation } from "react-i18next";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WebIcon from "@mui/icons-material/Web";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import IconButton from "@mui/material/IconButton";
import { linearGradient } from "pdfkit";

export default function ContactUsPage(props: {
  setTitle: Dispatch<React.SetStateAction<string>>;
}) {
  const { t } = useTranslation();

  useEffect(() => {
    props.setTitle("contactUs");
  }, []);

  return (
    <div>
      {/* <AppBar title={"聯絡我們"} /> */}
      <StyledContainer style={{ paddingTop: 90, paddingBottom: 80 }}>
        <Typography
          variant="h5"
          component="h2"
          align="center"
          style={{ marginTop: 30 }}
        >
          {t("contactUs.title")}
        </Typography>
        <Grid
          style={{ justifyContent: "center", display: "flex", marginTop: 30 }}
        >
          <Typography
            variant="subtitle1"
            component="h2"
            align="left"
            style={{ lineHeight: "250%", color: "grey" }}
          >
            MedMind Technology 醫念科技
            <br />
            {t("acc_key.phone")}/WhatsApp: 9624 9220 Thomas Cheung
            <br />
            {t("acc_key.email")}:{" "}
            <a href="mailto:info@medmindtechnology.hk">
              info@medmindtechnology.hk
            </a>
            <br />
            {t("contactUs.address")}: Unit 325 , 3/F, Building 19W, No. 19
            Science Park West Avenue, Hong Kong Science Park
            <br />
            <Tooltip title={"Facebook"}>
              <IconButton>
                <FacebookIcon
                  sx={{ color: "#4267B2" }}
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/medmindtechnology/",
                      "_blank"
                    )
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Instagram"}>
              <IconButton>
                <InstagramIcon
                  sx={{ color: "#E1306C" }}
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/medmind_technology/",
                      "_blank"
                    )
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={"LinkedIn"}>
              <IconButton>
                <LinkedInIcon
                  sx={{ color: "#0077B5" }}
                  onClick={() =>
                    window.open(
                      "https://hk.linkedin.com/company/medmind-technology-limited",
                      "_blank"
                    )
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("contactUs.website")}>
              <IconButton>
                <WebIcon
                  sx={{ color: "088F8F" }}
                  onClick={() =>
                    window.open("https://www.medmindtechnology.hk/", "_blank")
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("contactUs.email")}>
              <IconButton>
                <EmailIcon
                  sx={{ color: "#D2042D" }}
                  onClick={() =>
                    window.open("mailto: info@medmindtechnology.hk")
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={"WhatsApp"}>
              <IconButton>
                <WhatsAppIcon
                  sx={{ color: "#25D366" }}
                  onClick={() =>
                    window.open("https://wa.me/+85294120374", "_blank")
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("contactUs.call")}>
              <IconButton>
                <CallIcon
                  sx={{ color: "#228B22" }}
                  onClick={() => window.open("tel:94120374")}
                />
              </IconButton>
            </Tooltip>
          </Typography>
        </Grid>
        <Grid
          style={{
            justifyContent: "flex-end",
            display: "flex",
            marginTop: 30,
            alignContent: "flex-end",
          }}
        >
          <img
            src={logo}
            style={{ display: "block", marginTop: 50, marginBottom: 50 }}
          ></img>
        </Grid>
      </StyledContainer>
      {/* <AppBar title={"聯絡我們"} bottom={true} /> */}
    </div>
  );
}
